import styled, { css } from 'styled-components';
import { MainBtn, BlankBtn } from 'components/Buttons';

interface IInfo {
  open: boolean;
}

interface ICourseWrapper {
  isOpen: boolean;
}

export const CourseWrapper = styled.div<ICourseWrapper>`
  ${({ isOpen }) => css`
    opacity: ${isOpen ? `0.2` : `1`};
  `}

  width: 100%;
  min-height: 100vh;
`;

export const CourseModuleInfoWrapper = styled.div<IInfo>`
  height: 100%;
  transition: all 0.7s ease-in-out;
  margin-bottom: 60px;

  @media (max-width: 768px) {
  }

  .course-title {
    margin-top: 18px;
    margin-bottom: 26px;

    @media (max-width: 768px) {
      margin-top: 16px;
      margin-bottom: 16px;
    }

    h1 {
      color: var(--primary-color);
      font-family: 'Inter Bold';
      font-size: 20px;
    }
  }

  .sm-footer {
    display: none;
    padding-top: 20px;

    .material-course {
      background-color: var(--color-side-menu);
      margin-top: 40px;
      margin-bottom: 120px;
      width: 100vw;
      margin-left: -20px;
    }

    .progress {
      margin-top: 56px;
      margin-bottom: 15px;

      h1 {
        color: var(--secondary-color-light);
        text-transform: uppercase;
        letter-spacing: 1px;
        margin-bottom: 12px;
        font-size: var(--font-medium);
      }
    }

    @media (max-width: 768px) {
      display: flex;
      flex-direction: column;
    }
  }

  .container-course-content {
    display: flex;
    flex-direction: column;
    height: 100vh;
  }
`;

export const CourseModuleSelector = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin: 40px 0;
  border: 1px solid var(--primary-color);
  border-radius: 15px;
  padding: 20px 25px;

  @media (max-width: 768px) {
    margin-top: 0;
    flex-direction: column;
    align-items: flex-start;
  }

  .back-to-modules {
    color: var(--primary-color);
    display: flex;
    gap: 5px;
    padding: 14px 40px 14px 0;
    border-right: 1px solid var(--primary-color);
    cursor: pointer;

    @media (max-width: 768px) {
      border-right: none;
    }
  }

  .module-selector {
    position: relative;
    padding-left: 40px;

    @media (max-width: 768px) {
      padding-left: 0;
    }

    h2 {
      color: var(--primary-color);
      font-size: var(--font-large);
      font-family: 'Inter Bold';
      margin-bottom: 4px;
    }

    h3 {
      text-transform: uppercase;
      font-size: var(--font-small);
      font-weight: 400;
    }
  }
`;

export const CourseInfoActions = styled.div`
  margin: 0;
  padding: 15px 25px;

  .buttons {
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (max-width: 768px) {
      .time-duration {
        display: none;
      }
    }

    > div {
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }

  .sm-third-row {
    display: none;

    @media (max-width: 768px) {
      width: 100%;
      display: flex;
      flex-direction: column;

      .lesson-selector {
        display: flex;
        align-items: center;
        justify-content: space-around;
        padding: 18px 0;
        margin: 25px 0;
        border: 1px solid rgba(155, 153, 175, 0.31);

        h3 {
          text-transform: uppercase;
          font-size: var(--font-large);
          color: var(--primary-color-light);
        }

        .menu-bullet {
          width: 26px;
          height: 26px;
          cursor: pointer;
        }

        .arrow-left {
          width: 22px;
          height: 22px;
          transform: rotate(180deg);
          cursor: pointer;
        }
      }
    }
  }

  .divider {
    background-color: var(--secondary-color);
    opacity: 0.27;
    height: 1px;
    width: 100%;
    margin-top: 25px;
    margin-bottom: 30px;

    @media (max-width: 768px) {
      display: none;
    }
  }

  .info-author {
    display: flex;
    align-items: center;
    cursor: pointer;

    h1 {
      font-size: var(--font-medium);
      font-family: 'Inter Bold';
    }

    span {
      color: var(--primary-color);
    }

    img {
      height: 42px;
      width: 42px;
      margin-right: 13px;
      border-radius: 5px;
      object-fit: cover;
    }
  }
`;

export const CourseContentWrapper = styled.div`
  display: flex;
  gap: 2%;

  @media (max-width: 768px) {
    flex-direction: column;
  }

  .current-lesson-wrapper {
    width: 69%;

    @media (max-width: 768px) {
      width: 100%;
    }

    .video-wrapper {
      border-radius: 15px;
      background: #ffffff;
      box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
      border-radius: 15px;
      overflow: hidden;
    }
  }

  .sidebar {
    width: 29%;

    @media (max-width: 768px) {
      width: 100%;
    }

    .list-courses-wrapper {
      overflow: hidden;
      border: 1px solid var(--primary-color);
      border-radius: 15px;
    }

    .list-courses {
      padding: 15px 8px;
      max-height: 600px;
      overflow-y: scroll;
      overflow-x: hidden;
      scrollbar-color: var(--primary-color) var(--color-light-pink);
      scrollbar-width: thin;

      .list-title {
        color: var(--primary-color);
        font-family: 'Inter Bold';
        font-size: var(--font-large);
        margin-bottom: 12px;
        padding-left: 8px;
      }
    }
  }
`;

export const LessonMainBtn = styled(MainBtn)`
  height: 34px;
  padding: 0 22px;
`;

export const LessonEmptyBtn = styled(BlankBtn)`
  height: 34px;
  padding: 0 22px;
`;

export const CoursesListCard = styled.div`
  display: flex;
  gap: 10px;
  cursor: pointer;
  padding: 15px 8px;

  &.current-lesson {
    background-color: var(--color-light-pink);
    border-radius: 15px;

    h4 {
      color: var(--primary-color);
    }
  }

  .check-container {
    padding-top: 3px;
    .check {
    }

    .circle {
      border: 1px solid;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background-color: #fff;
    }
  }

  .lesson-content {
    h4 {
      font-family: 'Inter Bold';
    }

    .lesson-info {
      display: flex;
      gap: 15px;
      align-items: center;
      line-height: 1rem;
      margin-top: 10px;
      font-size: var(--font-small);

      .dot {
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background-color: var(--color-text);
      }
    }
  }
`;
